
import React from 'react';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import { setBaseLayerVisibility, setOverLayerVisibility } from './setVisibility';

import { Log } from '../../../core';
const log = Log.getLogger('MultiSceneForApp.layer.LayerSwitcherLegacyPanel');

const STYLE_GROUP_TITLE = {
    fontWeight: 'bold'
};

function getChoiceGroupOptions(layers, group, map) {
    let options = [];
    group.layers.forEach(layerId => {
        layers.forEach(layer => {
            if (layer.id === layerId) {
                let disabled = false;
                if (map.resolution) {
                    if (layer.maxResolution) {
                        disabled = disabled || (layer.maxResolution <= map.resolution);
                    }
                    if (layer.minResolution) {
                        disabled = disabled || (layer.minResolution > map.resolution);
                    }
                }

                options.push({
                    key: layer.id,
                    text: layer.title,
                    disabled: disabled,
                    layer: layer,
                    checked: layer.visible,
                    styles: {
                        root: {
                            marginTop: 0
                        }
                    }
                });
            }
        });
    })

    return options;
}

const BaseLayers = (props) => {
    let onChange = (event, option) => {
        log.debug(`set base layer visible: ${option.layer.id}=${!option.layer.visible}`);
        setBaseLayerVisibility(props.layers, option.layer, props.setLayerVisibility);
    };

    return (
        <ChoiceGroup
            options={getChoiceGroupOptions(props.layers, props.group, props.map)}
            onChange={onChange}
            label={props.group.title}
            styles={{
                label: STYLE_GROUP_TITLE
            }}
        />
    );
}

function getOverLayerCheckboxes(layers, group, map, onChange) {
    let checkboxes = [];
    group.layers.forEach(layerId => {
        layers.forEach(layer => {
            if (layer.id === layerId) {
                let disabled = false;
                if (map.resolution) {
                    if (layer.maxResolution) {
                        disabled = disabled || (layer.maxResolution <= map.resolution);
                    }
                    if (layer.minResolution) {
                        disabled = disabled || (layer.minResolution > map.resolution);
                    }
                }
                checkboxes.push(
                    <Checkbox
                        key={layer.id}
                        label={layer.title}
                        checked={layer.visible}
                        disabled={disabled}
                        layer={layer}
                        onChange={onChange.bind(this, layer)}
                    />
                );
            }
        });
    })
    return checkboxes;
}

const OverLayers = (props) => {
    const classNames = mergeStyleSets({
        label: STYLE_GROUP_TITLE
    });

    let onChange = (layer) => {
        log.debug(`set over layer visibility: ${layer.id}=${!layer.visible}`);
        setOverLayerVisibility(props.layers, layer, props.setLayerVisibility);
    };

    const stackTokens = {childrenGap: 4};

    return (
        <Stack tokens={stackTokens}>
            <Label className={classNames.label}>{props.group.title}</Label>
            {getOverLayerCheckboxes(props.layers, props.group, props.map, onChange)}
        </Stack>
    );
}

const LayerSwitcherLegacyPanel = (props) => {

    const classNames = mergeStyleSets({
        root: {
            padding: '4px'
        }
    });

    let baseGroup = props.groups.reduce((previous, current) => {
        return (current.base)
            ? current
            : previous;
    }, null);

    let overGroups = props.groups.filter(item => {
        return (!item.base);
    });

    const renderBaseLayers = () => {
        return (
            <BaseLayers
                layers={props.layers}
                group={baseGroup}
                map={props.map}
                setLayerVisibility={props.moduleActions.setLayerVisibility}
            />
        );
    }

    const renderOverLayers = () => {
        return overGroups.map(item => {
            return (
                <OverLayers
                    key={item.id}
                    layers={props.layers}
                    group={item}
                    map={props.map}
                    setLayerVisibility={props.moduleActions.setLayerVisibility}
                />
            );
        });
    }

    return (
        <Stack className={classNames.root}>
            {(props.onlyOverLayers !== true) && renderBaseLayers()}
            {renderOverLayers()}
        </Stack>
    );
};

export default LayerSwitcherLegacyPanel;
